/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * KeyIcon
 */
export default class KeyIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M15.5 1a7.5 7.5 0 11-2.717 14.493l-.348 1.984a1 1 0 01-1.062.824l-.11-.014-1.753-.333-.375 2.132a1 1 0 01-1.026.826l-.115-.011-2.527-.4-.796 1.888a1 1 0 01-.992.609l-.115-.016-2.75-.521a1 1 0 01-.807-.864L0 21.478v-4.174a1 1 0 01.25-.662l.087-.086 7.757-6.868A7.5 7.5 0 0115.5 1zm0 2a5.5 5.5 0 00-5.464 6.132l.044.312.06.098a1 1 0 01-.138 1.118l-.09.089L2 17.755v2.895l1.143.217.786-1.864a1 1 0 01.964-.61l.113.01 2.33.369.38-2.162a1 1 0 011.061-.824l.11.014 1.753.333.375-2.132a1 1 0 011.158-.812l-.053-.007a.996.996 0 01.68.111A5.5 5.5 0 1015.5 3zM17 5a2 2 0 110 4 2 2 0 010-4z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

